import React from "react";

function Footer() {
  return (
    <>
      <footer class="footer">
        <div class="container">
          <div class="row align-items-center flex-row-reverse">
            <div class="col-auto ml-lg-auto">
              <div class="row align-items-center">
                <div class="col-auto">
                  <ul class="list-inline list-inline-dots mb-0">
                    <li class="list-inline-item">
                      <a href="#">Terms & Conditions</a>
                    </li>
                   
                    <li class="list-inline-item">
                      <a href="#">Privacy Policy</a>
                    </li>
                     <li class="list-inline-item">
                      <a href="/refund-policy.pdf" download>Refund Policy</a>
                    </li>
                    <li class="list-inline-item">
                      <a href="#">FAQ</a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="col-12 col-lg-auto mt-3 mt-lg-0 text-center">
              Copyright © 2026 <a href="https://www.cnci.ac.in/">CNCI</a>. All rights reserved.
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}

export default Footer;